export enum ApiKeyCreationStep {
  Details,
  ManageAccess,
}

export enum ManageAccessTab {
  Roles = "roles",
  IdpGroups = "idp-groups",
}

export const API_KEY_CREATION_WIZARD_NAV_STEPS = [
  { name: "API key details", step: ApiKeyCreationStep.Details },
  { name: "Manage access", step: ApiKeyCreationStep.ManageAccess },
];
